var mainslide = document.querySelector(".index-mainslide");
if (mainslide) {
  new Splide(mainslide, {
    type: "fade",
    rewind: true,
    perPage: 1,
    autoplay: true,
    interval: 4000,
    pagination: false,
  }).mount();
}

var btmslider = document.querySelector(".index-btmslider");
if (btmslider) {
  new Splide(btmslider, {
    type: "fade",
    rewind: true,
    perPage: 1,
    autoplay: true,
    interval: 4000,
    pagination: false,
  }).mount();
}

var colecSlider = document.querySelector(".colec-list-slider");
if (colecSlider) {
  const splide = new Splide(colecSlider, {
    loop: 1,
    perPage: 3,
    perMove: 1,
    gap: '3rem',
    pagination: false,
    arrows: true, // explicitly state arrows
    breakpoints: {
      359: {
        perPage: 1,
        gap: '1rem'
      },
      640: {
        type: 'loop',
        perPage: 1,
        gap: '1rem',
        focus: 'center',
        padding: '20%'
      },
      768: {
        perPage: 3,
        gap: '1rem'
      },
      1024: {
        perPage: 3,
        gap: '1.5rem'
      },
    },
  });
  // Add has-arrows class after Splide is mounted
  splide.on('mounted', () => {
    if (colecSlider.querySelector('.splide__arrows')) {
      colecSlider.classList.add('has-arrows');
    }
  });
  // Mount Splide
  splide.mount();
}

var customerSlider = document.querySelector(".customer-sayslide");
if (customerSlider) {
  const splide = new Splide(customerSlider, {
    loop: 1,
    perPage: 5,
    perMove: 1,
    gap: '3rem',
    pagination: false,
    arrows: true,
    breakpoints: {
      640: {
        perPage: 2,
        gap: '1rem'
      },
      992: {
        perPage: 2,
        gap: '1.5rem'
      },
    },
  });
  // Add has-arrows class after Splide is mounted
  splide.on('mounted', () => {
    if (customerSlider.querySelector('.splide__arrows')) {
      customerSlider.classList.add('has-arrows');
    }
  });
  // Mount the Splide instance
  splide.mount();
}

var customerSlider = document.querySelector(".procustomer-sayslide");
if (customerSlider) {
  const splide = new Splide(customerSlider, {
    loop: 1,
    perPage: 3,
    perMove: 1,
    gap: '3rem',
    pagination: false,
    arrows: true,
    breakpoints: {
      640: {
        perPage: 1,
        gap: '1rem'
      },
      992: {
        perPage: 2,
        gap: '1.5rem'
      },
    },
  });
  // Add has-arrows class after Splide is mounted
  splide.on('mounted', () => {
    if (customerSlider.querySelector('.splide__arrows')) {
      customerSlider.classList.add('has-arrows');
    }
  });
  // Mount the Splide instance
  splide.mount();
}


// Add has-inner-banner class to the body if .inner-banner class exists
document.addEventListener('DOMContentLoaded', function() {
    var innerBanner = document.querySelector('.inner-banner');
    if (innerBanner) {
        document.body.classList.add('has-inner-banner');
    }
});


var catimageSlider = document.querySelector(".catimg--mobslide");
if (catimageSlider) {
  new Splide(catimageSlider, {
    loop: 1,
    perPage: 5,
    perMove: 1,
    gap: '1rem',
    pagination: false,
    arrows: false,
    breakpoints: {
      360: {
        perPage: 4,
        gap: '1rem'
      }
    },
  }).mount();
}


document.addEventListener('DOMContentLoaded', function() {
  if (window.jQuery) {
    $('.datepicker').datepicker({
      dateFormat: 'yy-mm-dd',      // Shopify-compatible format
      changeMonth: true,
      changeYear: true,
      yearRange: "1900:c",         // From 1900 to current year
      maxDate: 0                   // Disables future dates
    });
  }
});

 // (function () {
   // function hideDivabibaLoader() {

     // var loader = document.getElementById('divabiba-loader');

     // if (!loader) return;

    //  loader.classList.add('is-hidden');

     // setTimeout(function () {
     //   loader.remove();
     // }, 800);

   // }

  //  if (document.readyState === 'complete') {

     // setTimeout(hideDivabibaLoader, 400);

    //} else {

     // window.addEventListener('load', function () {

      //  setTimeout(hideDivabibaLoader, 400);

     // });

   // }

 // })();


//document.addEventListener('DOMContentLoaded', function () {
  //const productInfo = document.getElementById('product-info');

  //if (productInfo) {
   // const observer = new IntersectionObserver(
     // function ([entry]) {
       // if (!entry.isIntersecting) {
        //  productInfo.classList.add('scrolled-out');
        //} else {
        //  productInfo.classList.remove('scrolled-out');
       // }
      //},
      //{
        //root: null,
        //threshold: 0, // Trigger as soon as any part is not visible
      //}
   // );

    //observer.observe(productInfo);
  //}
//});

